import { jsx as _jsx } from "react/jsx-runtime";
import { useMessage } from '@tmapy/intl';
import { useLink } from '../hooks/useLink.js';
export const Link = ({ to, params, testId, children }) => {
    const formatMessage = useMessage();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { isSameRoute, isSameExactly, ...navigate } = useLink(to, params);
    return (_jsx("a", { ...navigate, "data-active": isSameRoute ? true : undefined, "data-test-id": testId, children: children ?? formatMessage({ id: `${to}.link` }, params) }));
};
//# sourceMappingURL=Link.js.map